<template>
  <div class="record-list">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>心情记录管理</span>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="用户ID">
          <el-input v-model="searchForm.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="recordList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="user_id" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="content" label="内容"></el-table-column>
        <el-table-column prop="emotion_score" label="情感分数" width="100"></el-table-column>
        <el-table-column prop="emotion_type" label="情感类型" width="120">
          <template #default="scope">
            <el-tag :type="getEmotionTypeTag(scope.row.emotion_type)">
              {{ getEmotionTypeText(scope.row.emotion_type) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template #default="scope">
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'RecordList',
  data() {
    return {
      recordList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      searchForm: { user_id: '' }
    }
  },
  mounted() {
    this.fetchRecordList()
  },
  methods: {
    // 获取心情记录列表
    fetchRecordList() {
      try {
        const token = localStorage.getItem('adminToken')
        fetch(`/api/admin/content/record-list?page=${this.currentPage}&pageSize=${this.pageSize}&user_id=${this.searchForm.user_id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.recordList = data.data.list
            this.total = data.data.total
          }
        })
      } catch (error) {
        this.$message.error('获取心情记录列表失败')
      }
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.fetchRecordList()
    },

    // 分页
    handleSizeChange(size) {
      this.pageSize = size
      this.fetchRecordList()
    },

    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchRecordList()
    },

    // 删除心情记录
    handleDelete(id) {
      this.$confirm('确定要删除该心情记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const token = localStorage.getItem('adminToken')
        fetch('/api/admin/content/delete-record', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ id })
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.$message.success('删除成功')
            this.fetchRecordList()
          } else {
            this.$message.error(data.message)
          }
        })
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 获取情感类型标签
    getEmotionTypeTag(type) {
      const tags = {
        1: 'success',
        2: 'warning',
        3: 'danger',
        4: 'info'
      }
      return tags[type] || 'info'
    },

    // 获取情感类型文本
    getEmotionTypeText(type) {
      const texts = {
        1: '积极',
        2: '中性',
        3: '消极',
        4: '其他'
      }
      return texts[type] || '未知'
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.record-list {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}
</style>
